import React, { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import StyledAlert from '@src/components/StyledAlert'
import { useAuth } from '@src/context/AuthContext'
import { useCategoryImageMap } from '@src/hooks/useCategoryImageMap'
import type { CatalogProduct, FeaturedProduct } from '@src/types'
import LandingPageHeader from '@design-components/LandingPageHeader'
import CategorySection from '@design-components/CategorySection'
import BenefitsSection from '@design-components/BenefitsSection'
import ProductFlyerModal from '@design-components/ProductFlyerModal'
import LoginModal from '@src/features/auth/LoginModal'

const BannerAlertWrapper = styled.div`
  .alert { border-radius: 0; border-left: none; border-right: none; margin: 0; text-align: center; }
`

const LandingPage: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState<CatalogProduct | FeaturedProduct | null>(null)
  const { user } = useAuth()
  const [searchParams, setSearchParams] = useSearchParams()
  const categoryImageMap = useCategoryImageMap()
  const bannerType = searchParams.get('banner')

  const openLoginModal = () => setSearchParams(prev => { prev.set('login', 'true'); return prev })

  return (
    <>
      {bannerType === 'session-expired' && (
        <BannerAlertWrapper>
          <StyledAlert variant="warning" dismissible onClose={() => setSearchParams(prev => { const p = new URLSearchParams(prev); p.delete('banner'); return p })}>
            <strong>Session Expired</strong>
            <div>Your session has expired. Please log in again to continue.</div>
          </StyledAlert>
        </BannerAlertWrapper>
      )}
      {bannerType === 'logout-success' && (
        <BannerAlertWrapper>
          <StyledAlert variant="success" dismissible onClose={() => setSearchParams(prev => { const p = new URLSearchParams(prev); p.delete('banner'); return p })}>
            <strong>Logged Out Successfully</strong>
            <div>You've been logged out. Come back soon!</div>
          </StyledAlert>
        </BannerAlertWrapper>
      )}

      <LandingPageHeader onProductClick={setSelectedProduct} />

      <CategorySection />

      <BenefitsSection />

      <ProductFlyerModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
        isAuthenticated={!!user}
        isAdmin={user?.is_admin || false}
        onLoginRequired={openLoginModal}
        categoryImageMap={categoryImageMap}
      />
      <LoginModal />
    </>
  )
}

export default LandingPage
